import { StandardReportUIProvider } from "./StandardReportUIContext";
import { StandardReportCard } from "./StandardReportCard";

export function StandardReportPage({
  term,
  date,
  dateEnd,
  sectionId,
  studentId
}) {  
  return (
    <StandardReportUIProvider standardReportParameters={{ term, date, dateEnd, sectionId, studentId }}>
      <StandardReportCard />
    </StandardReportUIProvider>
 );
}